// src/Login.js
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { withAuth } from "./WithAuth";
import "./Login.css";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      error: "",
    };
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { username, password } = this.state;
    const success = await this.props.auth.login(username, password);
    if (!success) {
      this.setState({ error: "Invalid username or password" });
    }
  };

  render() {
    const { authenticated } = this.props;
    if (authenticated) {
      return <Redirect to="/admin" />;
    }

    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1 className="login-title">GAMERLAN Admin</h1>
            <p className="login-subtitle">Sign in to your account</p>
          </div>
          
          <form onSubmit={this.handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username" className="form-label">Username</label>
              <input
                id="username"
                type="text"
                className="form-input"
                placeholder="Enter your username"
                value={this.state.username}
                onChange={(e) => this.setState({ username: e.target.value })}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password" className="form-label">Password</label>
              <input
                id="password"
                type="password"
                className="form-input"
                placeholder="Enter your password"
                value={this.state.password}
                onChange={(e) => this.setState({ password: e.target.value })}
                required
              />
            </div>
            
            {this.state.error && (
              <div className="error-message">
                <span className="error-icon">⚠</span>
                {this.state.error}
              </div>
            )}
            
            <button type="submit" className="login-button">
              Sign In
            </button>
          </form>
          
          <div className="login-footer">
            <p>&copy; 2024 GAMERLAN - Admin Portal</p>
          </div>
        </div>
      </div>
    );
  }
}

export default withAuth(Login);


// WEBPACK FOOTER //
// ./src/Components/Auth/Login.js